"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Field_1 = require("../../constants/Field");
var SupportedModelsProperties = /** @class */ (function () {
    function SupportedModelsProperties() {
    }
    SupportedModelsProperties.fromJson = function (json) {
        if (json === null || json === undefined) {
            throw new Error("Supported Models Properties are undefined");
        }
        var properties = new SupportedModelsProperties();
        properties.value = json.supportedModels.value;
        if (properties.value == null || properties.value == undefined) {
            throw new Error("Supported Model values are undefined");
        }
        return properties;
    };
    SupportedModelsProperties.prototype.toInstance = function () {
        var json = Object.create(null);
        json[Field_1.FIELD.SUPPORTEDMODELS] = this.value;
        return json;
    };
    SupportedModelsProperties.prototype.toInstanceWithValueField = function () {
        var json = Object.create(null);
        var valueJson = Object.create(null);
        valueJson[Field_1.FIELD.VALUE] = this.value;
        json[Field_1.FIELD.SUPPORTEDMODELS] = valueJson;
        return json;
    };
    return SupportedModelsProperties;
}());
exports.SupportedModelsProperties = SupportedModelsProperties;
//# sourceMappingURL=SupportedModelsProperties.js.map